export default __webpack_public_path__ + "static/media/Arrow_Right.96d44b5f.svg";